import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

export default class ErrorBannerComponent extends Component {
	@service errorManager;

	@action
	dismiss(id) {
		this.errorManager.removeError(id);
	}
}
